import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
import apiService from "../../../api/api.service";

export default {
  name: "point-of-contacts-list",
  components: { pageheader },
  data() {
    return {
      headers: [
        {
          text: "SNO",
          align: "center",
          sortable: false,
          value: "sno",
        },
        { text: "", value: "image", width: "5px", fixed: true },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },

        { text: "Action", value: "action" },
      ],
      search: "",
      dialog: false,
      contacts: [],
      options: {},
      loading: false,
      input: {},
      deleteId: null,
      delName: "",
      isdelete: false,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("pointofcontacts", this.roles);
    this.readDataFromAPI();
  },
  methods: {
    editContact(item) {
      this.$router.push({
        name: "editContact",
        params: { id: item.id },
        query: { type: "edit" },
      });
    },
    async readDataFromAPI() {
      this.loading = true;
      try {
        let contactsListRes;

        contactsListRes = await apiService.getAllUsers();

        if (contactsListRes) {
          this.loading = false;
          this.contacts = contactsListRes.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
        }
      } catch (err) {
        this.$toast.error("Unable to load the contacts" + err);
        this.loading = false;
      }
    },
    confirmDelete(item) {
      this.deleteId = item.id;
      this.delName = item.name;
      this.dialog = true;
    },
    async deleteContact() {
      try {
        this.isdelete = true;

        let delUser = await apiService.removeContact(this.deleteId);
        if (delUser) {
          this.isdelete = false;
          this.$toast.success(delUser.systemMessage);
          this.readDataFromAPI();
          this.dialog = false;
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete user" + err);
        this.dialog = false;
      }
    },
    clearSearch() {
      this.search = "";
      this.$router.replace(`/point-of-contacts/list`);
      this.readDataFromAPI();
    },
  },
};
